import { createSelector } from 'reselect'

const getShipsState = state => state.ships

export const selectShips = createSelector(
  getShipsState,
  state => state.data || [],
)

export const selectShipsIndexed = createSelector(selectShips, ships => {
  return ships.reduce((acc, cur) => {
    acc[cur.ship_code] = cur
    return acc
  }, {})
})
